import { datadogLogs } from '@datadog/browser-logs';

import { getEnv } from '../utilities/env';

const browserLogger = datadogLogs.logger;

const clientToken = 'pub696f3563bebcb1a1469bc378c47127b3'; // gitleaks:allow
const env = getEnv('APP_ENV');
const site = 'datadoghq.com';
const service = 'ets-request-manager-app';

if (env === 'staging' || env === 'production') {
    datadogLogs.init({
        clientToken: clientToken,
        site: site,
        service: service,
        env: env,
        forwardErrorsToLogs: false,
    });
}

type DatadogReservedAttributes =
    | 'status'
    | 'host'
    | 'source'
    | 'service'
    | 'message'
    | 'trace_id'
    | 'date'
    | '_id';

type LogContext = {
    [key: string]: unknown;
} & {
    [K in DatadogReservedAttributes]?: never;
};

export const datadogLogger = {
    error: logError,
    info: logInfo,
    warn: logWarn,
};

export function logError(message: string, context: LogContext = {}): void {
    if (env !== 'staging' && env !== 'production') {
        console.error(message, context);
        return;
    }

    return browserLogger.error(message, context);
}

function logInfo(message: string, context: LogContext = {}) {
    if (env !== 'staging' && env !== 'production') {
        console.info(message, context);
        return;
    }

    return browserLogger.info(message, context);
}

function logWarn(message: string, context: LogContext = {}) {
    if (env !== 'staging' && env !== 'production') {
        console.warn(message, context);
        return;
    }

    return browserLogger.warn(message, context);
}
